import React from "react";
import { useI18n } from "../lib/i18n";

export function Icon({ name, size = 20, strokeWidth = 1.8, className = "" }) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className,
    "aria-hidden": true,
  };

  const glyph = (() => {
    switch (name) {
      case "scale":
        return <><path d="M12 3v18M5 6h14M5 6 2.5 11h5L5 6Zm14 0-2.5 5h5L19 6ZM3 11c0 2 1 3 2 3s2-1 2-3m10 0c0 2 1 3 2 3s2-1 2-3M8 21h8" /></>;
      case "lock":
        return <><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" /></>;
      case "shield":
        return <><path d="M12 3 20 6v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-3Z" /><path d="m8.5 12 2.2 2.2 4.8-5" /></>;
      case "pin":
        return <><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></>;
      case "phone":
        return <path d="M5.2 3h3l1.4 4-2 1.7a16 16 0 0 0 7.7 7.7l1.7-2 4 1.4v3c0 1.2-1 2.2-2.2 2.2C10.1 21 3 13.9 3 5.2 3 4 4 3 5.2 3Z" />;
      case "mail":
        return <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m4 7 8 6 8-6" /></>;
      case "calendar":
        return <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M8 3v4m8-4v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" /></>;
      case "user":
        return <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>;
      case "menu":
        return <><path d="M4 7h16M4 12h16M4 17h16" /></>;
      case "close":
        return <><path d="m6 6 12 12M18 6 6 18" /></>;
      case "home":
        return <><path d="m3 11 9-8 9 8" /><path d="M5 10v11h14V10M9 21v-7h6v7" /></>;
      case "grid":
        return <><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></>;
      case "book":
        return <><path d="M4 5a3 3 0 0 1 3-2h5v17H7a3 3 0 0 0-3 2V5Zm16 0a3 3 0 0 0-3-2h-5v17h5a3 3 0 0 1 3 2V5Z" /></>;
      case "landmark":
        return <><path d="m3 9 9-6 9 6H3ZM5 10v8m5-8v8m4-8v8m5-8v8M3 21h18M2 18h20" /></>;
      case "building":
        return <><path d="M4 21V7l8-4v18M12 9h8v12M7 9h2m-2 4h2m-2 4h2m8-4h1m-1 4h1M2 21h20" /></>;
      case "document":
        return <><path d="M6 2h8l4 4v16H6V2Z" /><path d="M14 2v5h5M9 12h6m-6 4h6" /></>;
      case "upload":
        return <><path d="M12 16V4m0 0-5 5m5-5 5 5" /><path d="M5 14v6h14v-6" /></>;
      case "download":
        return <><path d="M12 4v12m0 0-5-5m5 5 5-5" /><path d="M5 20h14" /></>;
      case "plus":
        return <><path d="M12 5v14M5 12h14" /></>;
      case "search":
        return <><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></>;
      case "checklist":
        return <><path d="m4 6 2 2 4-4M4 13l2 2 4-4M13 6h7M13 13h7M4 20h16" /></>;
      case "gavel":
        return <><path d="m14 4 6 6M12 6l6 6M4 14l6 6M2 22h12M13 5 5 13l5 5 8-8-5-5Z" /></>;
      case "briefcase":
        return <><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V4h8v3M3 12h18M10 12v2h4v-2" /></>;
      case "family":
        return <><circle cx="9" cy="8" r="3" /><circle cx="17" cy="9" r="2.5" /><path d="M3 21a6 6 0 0 1 12 0M14 15a5 5 0 0 1 7 4.5" /></>;
      case "gazette":
        return <><path d="M5 3h14v18H5z" /><path d="M8 7h8M8 11h8M8 15h5" /></>;
      case "external":
        return <><path d="M14 3h7v7M10 14 21 3" /><path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" /></>;
      case "arrow":
        return <><path d="M5 12h14M14 7l5 5-5 5" /></>;
      case "arrowLeft":
        return <><path d="M19 12H5M10 7l-5 5 5 5" /></>;
      case "message":
        return <><path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8Z" /><path d="M8 9h8m-8 4h5" /></>;
      case "articles":
        return <><path d="M4 3h16v18H4z" /><path d="M8 7h8M8 11h8M8 15h5" /></>;
      case "logout":
        return <><path d="M10 17l5-5-5-5M15 12H3M15 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" /></>;
      case "edit":
        return <><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4L16.5 3.5Z" /></>;
      case "trash":
        return <><path d="M4 7h16M9 7V4h6v3m3 0-1 14H7L6 7m4 4v6m4-6v6" /></>;
      case "refresh":
        return <><path d="M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7" /></>;
      case "check":
        return <path d="m5 12 4 4L19 6" />;
      case "warning":
        return <><path d="m12 3 10 18H2L12 3Z" /><path d="M12 9v5m0 3h.01" /></>;
      default:
        return <circle cx="12" cy="12" r="9" />;
    }
  })();

  return <svg {...common}>{glyph}</svg>;
}

export function Brand({ logoUrl, compact = false }) {
  const { t } = useI18n();
  return (
    <span className={`brand ${compact ? "brand--compact" : ""}`}>
      {logoUrl ? <img className="brand__image" src={logoUrl} alt="Juris Prudent" /> : <span className="brand__mark"><Icon name="scale" size={compact ? 25 : 31} /></span>}
      <span className="brand__copy">
        <strong>Hasime Osmani-Vraniqi</strong>
        <small>{t("Avokate")}</small>
      </span>
    </span>
  );
}
